import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import { PRICE_UPDATE_STATUS } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/constants'

export type PriceUpdateTone = 'fresh' | 'stale' | 'outdated'

export type PriceUpdateAppearance = {
  text: string
  tone: PriceUpdateTone
}

/**
 * Подпись даты обновления прайса и тон бейджа.
 *
 * Пустая дата — нет подписи: статус без даты на странице не показываем.
 */
export default function formatPriceUpdateText(
  date: string | undefined,
  status: number,
): PriceUpdateAppearance | undefined {
  if (!date) {
    return undefined
  }

  if (status === PRICE_UPDATE_STATUS.FRESH) {
    return {
      text: `${tStatic('Обновлено клиникой')} ${date}`,
      tone: 'fresh',
    }
  }

  if (status === PRICE_UPDATE_STATUS.STALE) {
    return {
      text: `${tStatic('Обновлено клиникой')} ${date}. ${tStatic('Цены могли устареть')}`,
      tone: 'stale',
    }
  }

  if (status === PRICE_UPDATE_STATUS.OUTDATED) {
    return {
      text: `${tStatic('Обновлено клиникой')} ${date}. ${tStatic('Цены устарели')}`,
      tone: 'outdated',
    }
  }

  return undefined
}
